/** @format */

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../../global/form create/Popup";
import InputField from "../../inputs/inputField";
import InputTextarea from "../../inputs/inputTextarea";
import price from "../../../Assets/images/price.png";
import { toggleRender } from "../../../store/stateSlice";
import { postExpenses } from "../../../store/expenses";
import { useEffect } from "react";
import { getAllClients } from "../../../services/clintServices";
import SelectInput from "../../inputs/selectInput";
import { getAllDrivers } from "../../../store/drivers";
const AddExpense = ({ isOpen, toggleModal, setOpen }) => {
  //view pupup when onclick "اضافه مصروف"
  const dispatch = useDispatch();
  const errorMsgStore = useSelector((state) => state.expenses.errorMsg);
  const [errorMsg, seterrorMsg] = useState(errorMsgStore);

  const [values, setValues] = useState({
    render: false,
    driver_id: "",
    type: "",
    amount: "",
    notes: "",
  });
  function handleChange({ target }) {
    setValues({
      ...values,
      [target.name]: target.value,
    });
  }
  //function to sumbit data
  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(
      postExpenses({
        ...values,
        id: null,
      })
    ).then((res) => {
      if (res.payload.status === 200) {
        dispatch(toggleRender());
        setOpen(false);
      } else {
        setOpen(true);
        dispatch(toggleRender());
        setValues({ ...values, render: true });
      }
    });
  };
  //handel errormsg validation
  useEffect(() => {
    seterrorMsg(errorMsgStore);
  }, [errorMsgStore]);
  const handelError = (key) => {
    return (
      <span className="text-error">
        {" "}
        {errorMsg !== null && errorMsg !== undefined
          ? errorMsg[key]
          : null}{" "}
      </span>
    );
  };
  const drivers = useSelector((state) => state.drivers?.allDrivers);

  const [allDrivers , setAllDrivers] = useState([])

  //select drivers
  useEffect(() => {
    dispatch(getAllDrivers("/drivers")).then((res) =>{
      setAllDrivers(res.payload.data.data)
      
    });
  }, [dispatch]);
  
  const options = allDrivers.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const handleSelect = (e) => {
    setValues({ ...values, driver_id: e.value });
    if (errorMsg !== null && errorMsg !== undefined) {
      seterrorMsg({ ...errorMsg, driver_id: null });
    }
  };
  //select type
  const optionsType = [
    {
      value: "salary",
      label: "salary",
    },
    {
      value: "petrol",
      label: "petrol",
    },
  ];
  const handleSelectType = (e) => {
    setValues({ ...values, type: e.value });
    if (errorMsg !== null && errorMsg !== undefined) {
      seterrorMsg({ ...errorMsg, type: null });
    }
  };
  return (
    <Popup viewPupup={isOpen} hidePupup={toggleModal} viewWidth="content-xl">
      <form className="main-contnt" onSubmit={handleSubmit}>
        <div className="head-content">
          <div className="view-img">
            <img src={price} alt="price" />
          </div>
        </div>
        <div className="body-content">
          <SelectInput
            label="السائق المصروف له"
            placeholder="اختيار السائق"
            name="driver_id"
            options={options}
            handleSelect={handleSelect}
            note="*"
          />

          {handelError("driver_id")}
          <SelectInput
            label="نوع الصرف"
            placeholder="اختار نوع الصرف"
            name="type"
            options={optionsType}
            handleSelect={handleSelectType}
            note="*"
          />

          {handelError("type")}

          <InputField
            name="amount"
            title="قيمة الصرف "
            placeholder="اكتب قيمة الصرف"
            note="*"
            onChange={handleChange}
            value={values.amount}
          />
          {handelError("amount")}

          <InputTextarea
            name="notes"
            title="ملاحظات"
            placeholder="اكتب ملاحظات"
            note="*"
            onChange={handleChange}
            value={values.notes}
          />
          {handelError("notes")}
        </div>
        <div className="buttons-contnt display-flex center-flex ">
          <input value="اضافه" type="submit" class="btn btn__primary" />
          <div class="btn btn__danger" onClick={toggleModal}>
            الغاء
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default AddExpense;
